import type { BifrostWeb } from '@seekrtech/bifrost-web'

export interface DataServiceMethods {
  fullSync: () => Promise<void>
}

export function createDataService(bifrost: BifrostWeb): DataServiceMethods {
  return bifrost.createNativeProxy<DataServiceMethods>('DataService')
}
